import type { Option } from '@comparit/core';
import { HausratSelbstbeteiligung } from '../../../interfaces';

export const selbstbeteiligungOptions: Option<HausratSelbstbeteiligung>[] = [
  { label: '0 €', value: HausratSelbstbeteiligung.Eur0 },
  { label: '150 €', value: HausratSelbstbeteiligung.Eur150 },
  { label: '300 €', value: HausratSelbstbeteiligung.Eur300 },
  { label: '500 €', value: HausratSelbstbeteiligung.Eur500 },
  { label: '1.000 €', value: HausratSelbstbeteiligung.Eur1000 },
];
